import { render, staticRenderFns } from "./TasksGroup.vue?vue&type=template&id=0892c961&"
import script from "./TasksGroup.vue?vue&type=script&lang=js&"
export * from "./TasksGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports